import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateInboxEnrollmentForm as UpdateInboxEnrollmentFormMutation,
    UpdateInboxEnrollmentFormVariables as UpdateInboxEnrollmentFormMutationVariables,
    EnrollmentFormUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_FORM from '../mutations/update-enrollment-form.graphql';

export function useUpdateEnrollmentForm(): {
    updateEnrollmentForm: (arg1: EnrollmentFormUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [enrollmentFormUpdate, {loading: isLoading, error}] = useMutation<
        UpdateInboxEnrollmentFormMutation,
        UpdateInboxEnrollmentFormMutationVariables
    >(UPDATE_FORM);

    return {
        updateEnrollmentForm: (input: EnrollmentFormUpdateInput) =>
            enrollmentFormUpdate({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
